var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('spot-prices'),_vm._v(" "),_c('inventory-list',{attrs:{"inventory_config":_vm.inventory_config}}),_vm._v(" "),_c('announcement')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c08825dc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventory/Inventory.vue
// module id = 263
// module chunks = 1